/**
 * Created by razial on 13.03.2026.
 */

const EditorMap2dReferenceView = cc.Node.extend({
    ctor: function (reference) {
        this._super();

        this.reference = reference;

        this.reference.on("imagePositionChanged", this.updatePosition.bind(this));
        this.reference.on("imageOpacityChanged", () => this.setOpacity(this.reference.getImageOpacity()));
        this.reference.on("imageVisibilityChanged", () => this.setVisible(this.reference.isImageVisible()));
        this.reference.on("imageScaleChanged", () => this.setScale(this.reference.getImageScale()));
        this.reference.on("imageRotationChanged", () => this.setRotation(this.reference.getImageRotation()));
        this.reference.on("imageSkewChanged", () => {
            const skew = this.reference.getImageSkew();
            this.setSkewX(skew.x);
            this.setSkewY(skew.y);
        });

        const image = new cc.Sprite(this.reference.getImage());
        image.setAnchorPoint(0.5, 0.5);
        image.setPosition(image.width / 2, image.height / 2);
        this.addChild(image);

        this.setCascadeOpacityEnabled(true);
        this.setContentSize(image.width, image.height);
        this.setAnchorPoint(0.5, 0.5);
        this.setOpacity(this.reference.getImageOpacity());
        this.setVisible(this.reference.isImageVisible());
        this.setScale(this.reference.getImageScale());
        this.setRotation(this.reference.getImageRotation());
        this.setSkewX(this.reference.getImageSkew().x);
        this.setSkewY(this.reference.getImageSkew().y);
    },

    updatePosition: function () {
        const parent = this.getParent();
        if (parent) {
            const offset = this.reference.getImagePosition();
            this.setPosition(
                parent.width / 2 + offset.x,
                parent.height / 2 + offset.y
            );
        }
    }
});